<template>
  <div class="duplicate-candidate-icon">
    <i class="iconfont icona-bianzu53 background" :style="backGroundStyle"></i>
    <i class="iconfont iconexclamation-sign dot" :style="dotStyle" :class="dotPosition"></i>
  </div>
</template>

<script>

export default {
  props: {
    size: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: '#6b6a6a'
    },
    dotPosition: {
      type: String,
      default: 'right-bottom'
    },
    dotSize: {
      type: Number,
      required: false
    },
    dotColor: {
      type: String,
      default: '#ee7815'
    }
  },
  data () {
    return {

    }
  },
  computed: {
    backGroundStyle () {
      return {
        fontSize: `${this.size}px`,
        color: this.color
      }
    },
    dotStyle () {
      const dotSize = this.dotSize ? this.dotSize : this.size * 0.6
      const style = { color: this.dotColor }
      if (dotSize >= 12) {
        style.fontSize = `${dotSize}px`
      } else {
        style.fontSize = '12px'
        style.transform = `scale(${dotSize / 12})`
      }
      return style
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.duplicate-candidate-icon {
  display: inline-block;
  line-height: 1;
  position: relative;

  .background {

  }

  .dot {
    border-radius: 50%;
    background: #fff;
    position: absolute;
    z-index: 1;

    &.left-top {
      left: -2px;
      top: 0;
    }

    &.left-bottom {
      left: -2px;
      bottom: 0;
    }

    &.right-top {
      right: -2px;
      top: 0;
    }

    &.right-bottom {
      right: -3px;
      bottom: -3px;
    }
  }
}
</style>
